/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Button } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { SwitchButtonWithTrigger } from 'plugin-codaf-risk-ext-bowtie/generic'

import { AlarmSettingsCardsContainer } from './styles'

interface IProps {
    title: string
    text: string
    labelSwitch: string
    onSubmit: () => void
    textButton?: string
    nameIconButton?: string
    onSwitchChange?: (e: any) => void
    switchValue: boolean
}

export const AlarmSettingsCards: React.FC<IProps> = ({
    title,
    text,
    labelSwitch,
    children,
    textButton,
    nameIconButton,
    onSubmit,
    onSwitchChange,
    switchValue
}) => {
    return (
        <AlarmSettingsCardsContainer>
            <label className="label-title">{i18n(title)}</label>
            <label className="label-text">{i18n(text)}</label>
            <SwitchButtonWithTrigger
                id={title}
                label={i18n(labelSwitch)}
                disabled={false}
                value={switchValue ?? false}
                onChange={onSwitchChange}
                optionalFunctionTrigger={() => {
                    return false
                }}
            />
            {children}
            <div className="button">
                {textButton && (
                    <Button
                        className="no-outline-button"
                        bsStyle="primary"
                        onClick={onSubmit}
                        id="barrierList-list-button-newBarrier"
                        style={{ width: 160 }}
                    >
                        {nameIconButton ? <i className={nameIconButton} /> : null}
                        {i18n(textButton)}
                    </Button>
                )}
            </div>
        </AlarmSettingsCardsContainer>
    )
}
